import React from 'react';
import { motion } from 'framer-motion';
import { Scale, X, Check } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
const comparisons = [{
  negative: '3 a 5 horas por semana buscando tips en redes',
  positive: '10 minutos al día siguiendo un mapa claro'
}, {
  negative: 'Siempre los mismos pensamientos destructivos',
  positive: 'Plan de emergencia mental listo para usar'
}, {
  negative: 'Crisis por acumulación de estímulos',
  positive: 'Mente limpia y enfoque protegido'
}, {
  negative: 'Vivir en piloto automático y con queja pasiva',
  positive: 'Responsabilidad total y dirección clara'
}, {
  negative: 'Cero estructura visible de avance',
  positive: 'Sistema directo al próximo nivel emocional'
}];
export function ComparisonTable() {
  return <section className="py-24 px-6 border-b border-ink/10 bg-bone-dark/30" data-id="element-28">
      <div className="max-w-editorial mx-auto" data-id="element-29">
        <SectionHeader number="07" title="⚖️ LA REALIDAD: ¿Qué te cuesta NO tenerlo?" align="center" data-id="element-30" />

        <div className="mt-16 max-w-4xl mx-auto" data-id="element-31">
          {/* Desktop Header */}
          <div className="hidden md:grid grid-cols-2 gap-8 mb-6 px-6" data-id="element-32">
            <h4 className="text-xl font-serif text-oxblood text-center" data-id="element-33">
              Sin el Sistema
            </h4>
            <h4 className="text-xl font-serif text-sage text-center" data-id="element-34">
              Con el Sistema
            </h4>
          </div>

          <div className="space-y-4" data-id="element-35">
            {comparisons.map((row, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-36">
                {/* Negative Column */}
                <div className="flex-1 bg-bone border border-oxblood/20 p-5 rounded-sm flex items-start gap-3" data-id="element-37">
                  <X size={20} className="text-oxblood shrink-0 mt-0.5" data-id="element-38" />
                  <span className="text-ink-light font-sans" data-id="element-39">
                    {row.negative}
                  </span>
                </div>

                {/* Positive Column */}
                <div className="flex-1 bg-bone border border-sage/30 p-5 rounded-sm flex items-start gap-3" data-id="element-40">
                  <Check size={20} className="text-sage shrink-0 mt-0.5" data-id="element-41" />
                  <span className="text-ink font-medium font-sans" data-id="element-42">
                    {row.positive}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}